<template>
  <div class="purchase botPage">
    <mbHeader :title="$t('checkOut')" :lang="true" :left="true"></mbHeader>
    <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
      <div class="complementary hidden-sm-and-up">
        <el-collapse accordion v-model="accordionOpen">
          <el-collapse-item name="accordion">
            <template slot="title">
              <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg" class="order-summary-toggle__icon">
                <path
                  d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"></path>
              </svg>
              <span v-if="this.accordionOpen === 'accordion'"><span>{{ $t('hideOrderSummary') }}</span></span>
              <span v-else>{{ $t('showOrderSummary') }}</span>
              <span class="order-summary-toggle__total-recap total-recap">
                <span class="total-recap__final-price">${{ this.GrandTotal }}</span>
              </span>
            </template>
            <div class="sidebar hidden-sm-and-up">
              <div class="sidebar__header"></div>
              <div class="sidebar__content">
                <div class="order-summary order-summary--is-collapsed">
                  <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                  <div class="order-summary__sections">
                    <div
                      class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable">
                      <div class="order-summary__section__content">
                        <table class="product-table">
                          <tr class="product"
                              v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                            <td class="product__image" @click="goToProductDetail(item)">
                              <div class="product-thumbnail">
                                <div class="product-thumbnail__wrapper">
                                  <img :src="item.Thumbnail" alt="">
                                </div>
                                <span class="product-thumbnail__quantity">{{ item.Quantity }}</span>
                              </div>
                            </td>
                            <th class="product__description">
                            <span class="product__description__name order-summary__emphasis">{{ curIsEnglish ? item.Name : item.Description }}</span>
                            <span class="product__description__variant order-summary__small-text"></span>
                            </th>
                            <td class="product__price">
                              <span class="order-summary__emphasis">
                                ${{ item.TotalPrice.toFixed(2) }}
                              </span>
                            </td>
                          </tr>

                        </table>
                        <div style="display: none" class="order-summary__scroll-indicator">
                          {{ $t('scrollMoreItems') }}
                          <i class="el-icon-bottom"></i>
                        </div>
                      </div>
                    </div>
                    <div v-if="!this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid"
                         class="order-summary__section order-summary__section--discount">
                      <div class="discount" :class="'promoCode' ? 'discountCode' : ''">
                        <el-form-item label="Discount code">
                          <couponAutocomplete v-model="promoCode"></couponAutocomplete>
                        </el-form-item>
                        <el-button @click="validatePromotionCode($event)" class="field__input-btn btn">
                          <span class="btn__content visually-hidden-on-mobile">{{ $t('apply') }}</span>
                        </el-button>
                      </div>
                    </div>
                    <div class="promocode-successful"
                         v-else-if="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid">
                      <h3>{{ $t('promoApplied') }}</h3>
                      <span @click="resetPromotionCode" class="change-btn">{{ $t('change') }}</span>
                    </div>
                    <div v-else-if="this.promoCodeValid && !this.promoCodeSuccessful && !this.promoCodeLoading"
                         class="order-summary__section order-summary__section--discount">
                      <div class="discount" :class="promoCode ? 'discountCode' : ''">
                        <el-form-item label="Discount code">
                          <couponAutocomplete v-model="promoCode"></couponAutocomplete>
                        </el-form-item>
                        <el-button @click="validatePromotionCode($event)" class="field__input-btn btn ch-btn-not-valid">
<!--                          <span>{{ $t('inputValidPromo') }}</span>-->
                          {{ notValid }}
                          <!-- Leaving the below button in case myumyu dislikes the new version. -->
                          <!-- <span class="btn__content visually-hidden-on-mobile">Apply</span> -->
                        </el-button>
                      </div>
                    </div>
                    <div class="order-summary__section order-summary__section--total-lines">
                      <table class="total-line-table">
                        <tbody class="total-line-table__tbody">
                        <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('subtotal') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          ${{ this.TotalPrice.toFixed(2) }}
                        </span>
                          </td>
                        </tr>
                        <tr class="total-line total-line--shipping">
                          <th class="total-line__name">
                            <span>{{ $t('shipping_fee') }}</span>
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__small-text">
                          ${{ necessaryCartItems.Delivery }}
                        </span>
                          </td>
                        </tr>
                        <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('tax') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          ${{ necessaryCartItems.Tax }}
                        </span>
                          </td>
                        </tr>
                        <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('promotion') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{ this.Savings.toFixed(2) }}
                        </span>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="total-line-table__footer">
                        <tr class="total-line">
                          <th class="total-line__name total_name payment-due-label">
                      <span class="payment-due-label__total">
                        {{ $t('total') }}
                      </span>
                            <span class="payment-due-label__taxes order-summary__small-text hidden">
                        {{ $t('including') }}
                        <span class="">$0.00</span>
                        {{ $t('tax') }}
                      </span>
                          </th>
                          <td class="total-line__price usd_price payment-due">
                        <span class="payment-due__currency">
                          USD
                        </span>
                            <span class="payment-due__price">${{ this.GrandTotal }}</span>
                          </td>
                        </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wrap">
        <div class="main">
          <h2 class="payment-head">{{ $t('you_almost_there') }}</h2>
          <!-- <div
            v-if="!this.checkoutWithinRadius && this.deliveryMethodIsDelivery && (this.shippingAddressSelected || this.billingAddressSelected)">
            <span class="error-message">{{ $t('notInArea') }}</span>
          </div> -->
          <div class="step-breadcrumb">
            <p @click="goBackToStep($event, 1, stepOneValid)" :class="paymentStep === 1 ? 'active' : ''">{{
                $t('step1')
              }}</p>
            <p> / </p>
            <p @click="goBackToStep($event, 2, stepTwoValid)"
               :class="paymentStep === 2 ? 'active' : deliveryMethodIsPickup ? 'disabled' : '' ">
              {{ $t('step2') }}</p>
            <p> / </p>
            <p @click="goBackToStep($event, 3, stepThreeValid)" :class="paymentStep === 3 ? 'active' : '' ">
              {{ $t('step3') }}</p>
            <transition name="unroll">
              <p
                v-if="!this.savedCardSelected && (this.paymentMethod !== 'wechatpay' && this.paymentMethod !== 'alipay')">
                / </p>
            </transition>
            <transition name="unroll">
              <p
                v-if="!this.savedCardSelected && (this.paymentMethod !== 'wechatpay' && this.paymentMethod !== 'alipay')"
                :class="paymentStep === 4 ? 'active' : ''">{{ $t('step4') }}</p>
            </transition>
          </div>
          <div v-if="paymentStep === 1" class="step-one">
            <div class="delivery-container">
              <h3>{{ $t('pickup_delivery_date') }}</h3>
              <div class="delivery-btn-container">
                <button :class="deliveryMethodIsDelivery ? 'delivery-btn' : 'pickup-btn'"
                        @click="selectDeliveryMethod($event, DELIVERY_TEXT)">{{ $t('delivery') }}
                </button>
                <!-- <button :class="deliveryMethodIsPickup ? 'delivery-btn' : 'pickup-btn'"
                        @click="selectDeliveryMethod($event, PICKUP_TEXT)">
                  {{ $t('pick_up') }}
                </button> -->
              </div>
              <div class="select-container" v-if="this.deliveryMethodIsDelivery">
                <!-- <div class="standard">
                  <el-radio v-model="deliveryChoice" :disabled="!oneDayDelivery" v-bind:label="'oneDay'" type="checkbox"
                            class="address-select"/>
                  <div class="box-cont">
                    <p class="check-title">{{ $t('one_day_shipping') }}</p>
                    <transition name="unroll">
                      <p v-if="this.deliveryChoice === 'oneDay'" class="delivery-notification">{{
                          $t('your_order_will')
                        }}: {{ this.timeSlots[0].name }}</p>
                    </transition>
                    <transition name="unroll">
                      <p class="footnote" v-if="this.deliveryChoice !== 'oneDay'">{{ $t('order_before_12') }}</p>
                    </transition>
                  </div>
                </div> -->
                <div class="shipping-select">
                  <el-radio v-model="deliveryChoice" v-bind:label="'select'" type="checkbox" class="address-select"
                            checked="true"/>
                  <div class="box-cont">
                    <p class="check-title">{{ $t('pick_a_delivery_date') }}</p>
                    <p class="check-blurb" v-if="deliveryTime">{{ deliveryTime }}</p>
                    <p class="footnote">{{ $t('order_before_12') }}</p>
                    <p class="footnote">{{ $t('order_before_tip') }}</p>
                    <el-select class="element-select" v-model="deliveryTime" :placeholder="$t('select_a_time')"
                               :disabled="deliveryChoice !== 'select'">
                      <el-option
                        :disabled="deliveryChoice !== 'select'"
                        v-for="item in timeSlots"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>

                    <div class="change" v-if=" deliveryChoice !== 'select' " style="display: none">
                      {{ $t('select_a_time') }}
                    </div>
                    <div class="change activeC" v-else style="display: none" @click="showpop = !showpop">
                      {{ $t('select_a_time') }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="pickup-locale">
                  <div class="warehouse-content">
                    <el-radio type="checkbox" class="address-select" v-model="warehouseChoice"
                              :label="this.warehouses[0].value"/>
                    <img src="../assets/img/location.svg" class="warehouse-img"/>
                    <div class="warehouse-txt">
                      <p class="bolded weighted">{{ this.warehouses[0].name }}</p>
                      <p class="weighted">{{ this.warehouses[0].address }}</p>
                      <div class="bordered"></div>
                      <p>{{ this.warehouses[0].phone }}</p>
                      <p>{{ this.warehouses[0].hoursOne }}</p>
                      <p v-if="this.warehouses[0].hoursTwo">{{ this.warehouses[0].hoursTwo }}</p>
                    </div>
                    <div class="change activeC" style="display: none">change</div>
                  </div>
                  <div class="warehouse-content">
                    <el-radio type="checkbox" class="address-select" :disabled="true" v-model="warehouseChoice"
                              :label="this.warehouses[1].value"/>
                    <img src="../assets/img/location.svg" class="warehouse-img"/>
                    <div class="warehouse-txt">
                      <p class="bolded weighted">{{ this.warehouses[1].name }}</p>
                      <p class="weighted">{{ this.warehouses[1].address }}</p>
                      <div class="bordered"></div>
                      <p>{{ this.warehouses[1].phone }}</p>
                      <p>{{ this.warehouses[1].hoursOne }}</p>
                      <p v-if="this.warehouses[1].hoursTwo">{{ this.warehouses[1].hoursTwo }}</p>
                    </div>
                    <div class="change" style="display: none">change</div>
                  </div>
                  <div class="warehouse-content">
                    <el-radio type="checkbox" class="address-select" :disabled="true" v-model="warehouseChoice"
                              :label="this.warehouses[2].value"/>
                    <img src="../assets/img/location.svg" class="warehouse-img"/>
                    <div class="warehouse-txt">
                      <p class="bolded weighted">{{ this.warehouses[2].name }}</p>
                      <p class="weighted">{{ this.warehouses[2].address }}</p>
                      <div class="bordered"></div>
                      <p>{{ this.warehouses[2].phone }}</p>
                      <p>{{ this.warehouses[2].hoursOne }}</p>
                      <p v-if="this.warehouses[2].hoursTwo">{{ this.warehouses[2].hoursTwo }}</p>
                    </div>
                    <div class="change" style="display: none">change</div>
                  </div>
                </div>

                <div class="pickup-locale showmobile">
                  <div class="warehouse-content">
                    <img src="../assets/img/location.svg" class="warehouse-img"/>
                    <div class="warehouse-txt">
                      <p class="bolded weighted">{{ this.warehouses[0].name }}</p>
                      <p class="weighted">{{ this.warehouses[0].address }}</p>
                      <div class="bordered"></div>
                      <p>{{ this.warehouses[0].phone }}</p>
                      <p>{{ this.warehouses[0].hoursOne }}</p>
                      <p v-if="this.warehouses[0].hoursTwo">{{ this.warehouses[0].hoursTwo }}</p>
                    </div>
                    <div class="change activeC" @click="showPick = !showPick" style="display: none">change</div>
                  </div>
                </div>

                <div class="pickup-time">
                  <el-radio type="checkbox" class="address-select"/>
                  <img src="../assets/img/time2.png" style="display: none"/>
                  <div class="pickup-container">
                    <h3 class="pick-up-time">{{ $t('pick_up_time') }}</h3>
                    <h3 v-if="pickUpTime">{{ pickUpTime }}</h3>

                    <p v-if="this.dateSelected==='2021-11-26'" class="error-message">{{ $t('pickupWarning') }}</p>
                    <div class="day-select">
                      <calendar @clicked="storeDate"/>
                    </div>
                    <div class="time-select">
                      <el-select class="timeSlot-select" v-model="pickUpTime" :placeholder="$t('select_a_time')"
                                 :disabled="!dateSelected">
                        <el-option
                          v-for="item in pickUpTimeSlots"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <div class="bordered"></div>
                      <p>{{ $t('pickup_two_hours') }}</p>
                    </div>
                  </div>
<!--                  <div class="change activeC" style="display: none">Schedule</div>-->
                </div>
              </div>
            </div>
            <div class="next-step-1">
              <button :class="this.stepOneValid ? 'next-step-btn' : 'next-step-btn-invalid'"
                      @click="nextStep($event, 2)" :disabled="!this.stepOneValid">
                {{ $t('continue') }}
              </button>
            </div>
          </div>
          <div v-if="paymentStep === 2" class="step-two">
            <div class="delivery-container">
              <h3>2. {{ $t('shipping') }}</h3>
              <div class="address-select" v-show="addresses && addresses.length > 0" style="marginTop: 50px">
                <img v-show="shippingAddressSelected" src="../assets/img/times.svg" @click="clearShipping"
                     style="cursor: pointer"/>
                <el-select
                  class="element-select"
                  v-model="shippingAddressSelected"
                  popper-class="address-select-el-component"
                  :placeholder="$t('select_an_address')">
                  <el-option
                    v-for="item in addresses"
                    :key="item.CustomerDetail_id"
                    :label="item.Street + ', ' + item.City + ', ' + item.State + ' ' + item.Zip"
                    :value="item.CustomerDetail_id"
                  >
                    <div class="address-option-container">
                      <span>{{ item.Street + ', ' + item.City + ', ' + item.State + ' ' + item.Zip }}</span>
                      <i class="el-icon-delete" @click.stop="openConfirmationDeleteAlert(item.CustomerDetail_id, delAddressCallback)"></i>
                    </div>
                  </el-option>
                </el-select>
              </div>
              <!-- <p> select an address or input a new one. </p> -->
              <transition name="unroll">
                <div class="ship-form" v-show="!shippingAddressSelected">
                  <div class="input-item">
                    <p class="input-title">{{ $t('name') }}</p>
                    <input class="input-box" placeholder="Shop" v-model="shippingAddress.Name"
                           @keyup="checkShippingForm"/>
                  </div>
                  <div class="input-item">
                    <p class="input-title">{{ $t('address') }}</p>
                    <input
                      class="input-box"
                      :placeholder="$t('enter_delivery_address')"
                      v-model="shippingAddress.Address"
                      ref="ship-address"
                      @keyup="checkShippingForm"/>
                  </div>
                  <div class="input-item-dual">
                    <div class="input-itemcity">
                      <p class="input-title">{{ $t('city') }}</p>
                      <input
                        class="input-box"
                        placeholder="Seattle"
                        v-model="shippingAddress.City"
                        @keyup="checkShippingForm"/>
                    </div>
                    <div class="input-itemzip">
                      <p class="input-title">{{ $t('zipCode') }}</p>
                      <input
                        class="input-box"
                        placeholder="98033"
                        v-model="shippingAddress.Zipcode"
                        @keyup="checkShippingForm"/>
                    </div>
                  </div>
                  <div class="input-item-dual">
                    <div class="input-itemcity">
                      <p class="input-title">{{ $t('country') }}</p>
                      <input
                        class="input-box"
                        placeholder="USA"
                        value="USA"
                        disabled="true"
                        v-model="shippingAddress.Country"
                        ref="country"
                        @keyup="checkShippingForm"/>
                    </div>
                    <div class="input-itemzip">
                      <p class="input-title">{{ $t('phone') }}</p>
                      <input
                        class="input-box"
                        placeholder="(000) 000 0000"
                        v-model="shippingAddress.Telephone"
                        @keyup="formatPhone($event)"
                        @keydown="formatEnforce($event)"/>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="next-step-container">
                <button :class="shippingAddressValid() ? 'next-step-btn' : 'next-step-btn-invalid'"
                        @click="nextStepAddress($event, null, 'shipping')">
                  <!-- {{ $t('continue') }} -->
                  {{ $t('submit') }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="paymentStep === 3" class="step-three">
            <div class="delivery-container">
              <h3>{{ $t('enter_payment_details') }}</h3>
              <div v-if="this.orderFailed && this.paymentStep === 3">
                  <span class="error-message">
                    {{ $t('error') }} {{ this.orderFailMessage }}
                  </span>
              </div>
              <div class="payment-radios">
                <div class="radio">
                  <el-radio type="checkbox" label="creditcard" v-model="paymentMethod" class="payment-input"
                            @click="checkPaymentMethod($event)">
                    <i class="fab fa-cc-amex fa-3x" style="color: #C0C4CC; marginRight: 5px;"></i>
                    <i class="fab fa-cc-visa fa-3x" style="color: #C0C4CC; marginRight: 5px;"></i>
                    <i class="fab fa-cc-mastercard fa-3x" style="color: #C0C4CC; marginRight: 5px;"></i></el-radio>
                </div>
                <div class="radio wxs" :class="{iswx:isWx}">
                  <el-radio className="radio-purchase" v-model="paymentMethod" label="wechatpay"><span><i
                    class="fab fa-weixin fa-3x" style="color: #C0C4CC;"></i></span></el-radio>
                </div>
                <div class="radio">
                  <el-radio className="radio-purchase" v-model="paymentMethod" label="alipay"><span><i
                    class="fab fa-alipay fa-3x" style="color: #C0C4CC;"></i></span></el-radio>
                </div>
              </div>
              <transition name="unroll">
                <div>
                  <div class="address-select" v-show="paymentMethod === 'creditcard' && savedCards && savedCards.length > 0"
                       style='marginBottom: 50px'>
                    <img v-show="savedCards && savedCards.length > 0" src="../assets/img/times.svg" @click="clearSavedCard"
                         style="cursor: pointer"/>
                    <el-select class="element-select" v-model="savedCardSelected" :placeholder="$t('select_saved_card')">
                      <el-option
                        v-for="item in savedCards"
                        :key="item.profileId"
                        :label="`${item.cardType}` + ': ' + `${item.cardNumber}`"
                        :value="item.profileId"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="payment-form" v-show="paymentMethod === 'creditcard' && !savedCardSelected">
                    <div class="input-item">
                      <p class="input-title">{{ $t('name_checkout') }}</p>
                      <input class="input-box" v-model="cardInfo.Name" @keyup="paymentFormValid" autocomplete="off"/>
                    </div>
                    <div class="input-item">
                      <p class="input-title">{{ $t('card_number') }}</p>
                      <input
                        class="input-box"
                        v-model="cardInfo.CardNumber"
                        @input="cardNumberFormatter(cardInfo.CardNumber)"
                        @keyup="paymentFormValid"
                      />
                    </div>
                    <div class="input-item-dual">
                      <div class="input-itemcity">
                        <p class="input-title">{{ $t('expiration_date') }}</p>
                        <input
                          class="input-box"
                          v-model="cardInfo.ExpirationDate"
                          @input="cardExpireDateFormatter(cardInfo.ExpirationDate)"
                          @keyup="paymentFormValid"
                          placeholder="MM/YY"
                          maxlength="5"
                        />
                      </div>
                      <div class="input-itemzip">
                        <p class="input-title">CVV</p>
                        <input
                          class="input-box"
                          v-model="cardInfo.CVV"
                          @keyup="paymentFormValid"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                  </div>
<!--                  店内取货的时候才显示 -->
                  <div class="payment-form" v-if="deliveryMethodIsPickup">
                    <div class="input-item">
                      <p class="input-title">{{ $t('phone') }}</p>
                      <input
                        class="input-box"
                        placeholder="(000) 000 0000"
                        v-model="orderDataNote"
                        @keyup="formatPhone($event)"
                        @keydown="formatEnforce($event)"/>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="next-step-container">
                <div class="address-save" v-show="paymentMethod === 'creditcard' && !savedCardSelected">
                  <input type="checkbox" v-model="saveCard"/>
                  <p>{{ $t('save_card_future') }}</p>
                </div>
                <!-- 店内取货 -->
                <button
                  v-if="deliveryMethodIsPickup"
                  :class="(stepThreeValid && orderDataNote) ? 'next-step-btn' : 'next-step-btn-invalid'"
                  @click="nextStepPayment($event)">
                  {{ $t('continue') }}
                </button>
                <!-- 配送 -->
                <button
                  v-if="deliveryMethodIsDelivery"
                  :class="stepThreeValid ? 'next-step-btn' : 'next-step-btn-invalid'"
                  @click="nextStepPayment($event)">
                  {{ $t('continue') }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="paymentStep === 4" class="step-four">
            <div class="delivery-container">
              <h3>{{ $t('billing') }}</h3>
              <div v-if="this.orderFailed && this.paymentStep === 4">
                  <span class="error-message">
                    {{ $t('error') }} {{ this.orderFailMessage }}
                  </span>
              </div>
              <div class="shipping-options">
                <div class="address-select" v-show="addresses && addresses.length > 0">
                  <img v-show=billingAddressSelected src="../assets/img/times.svg" @click="clearBilling"
                       style="cursor: pointer"/>
                  <el-select class="element-select" v-model="billingAddressSelected"
                             :placeholder="$t('select_billing_address')">
                    <el-option
                      v-for="item in addresses"
                      :key="item.CustomerDetail_id"
                      :label="`${item.Street}` + ', ' + `${item.City}` + ', ' + `${item.State}` + ' ' + `${item.Zip}`"
                      :value="item.CustomerDetail_id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="address-save" v-show="!billingAddressSelected && deliveryMethod === DELIVERY_TEXT">
                  <input type="checkbox" v-model="billingAddressSame"/>
                  <p class="shipping-select">{{ $t('same_as_shipping') }}</p>
                </div>
              </div>
              <div class="ship-form" v-show="!billingAddressSelected && !billingAddressSame">
                <div class="input-item">
                  <p class="input-title">{{ $t('name') }}</p>
                  <input class="input-box" placeholder="Shop" v-model="billingAddress.Name"/>
                </div>
                <div class="input-item">
                  <p class="input-title">{{ $t('address') }}</p>
                  <input class="input-box" :placeholder="$t('enter_billing_address')" v-model="billingAddress.Address"/>
                </div>
                <div class="input-item-dual">
                  <div class="input-itemcity">
                    <p class="input-title">{{ $t('city') }}</p>
                    <input class="input-box" placeholder="Seattle" v-model="billingAddress.City"/>
                  </div>
                  <div class="input-itemzip">
                    <p class="input-title">{{ $t('zipCode') }}</p>
                    <input class="input-box" placeholder="98033" v-model="billingAddress.Zipcode"/>
                  </div>
                </div>
                <div class="input-item">
                  <p class="input-title">{{ $t('phone') }}</p>
                  <input
                    class="input-box"
                    placeholder="(000) 000 0000"
                    v-model="billingAddress.Telephone"
                    @keyup="formatPhone($event)"
                    @keydown="formatEnforce($event)"/>
                </div>
              </div>
              <div class="next-step-container">
                <!-- <div class="address-save">
                  <input type="checkbox" v-model="saveBillingAddress"/>
                  <p >Save address for future use</p>
                </div> -->
                <button :class="billingAddressValid() ? 'next-step-btn' : 'next-step-btn-invalid'"
                        @click="postBillingAndSubmitOrder($event)">
                  {{ $t('continue') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar hidden-sm-and-down">
          <div class="sidebar__header"></div>
          <div class="sidebar__content">
            <div class="order-summary order-summary--is-collapsed">
              <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
              <div class="order-summary__sections">
                <div
                  class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable"
                  ref="infoBox">
                  <div class="order-summary__section__content">
                    <div class="cart-products">
                      <div class="cartItems-header">
                        <p>{{ $t('product') }}</p>
                        <p>{{ $t('unit_price') }}</p>
                        <p>{{ $t('quantity') }}</p>
                        <p>{{ $t('total') }}</p>
                      </div>
                      <ul>
                        <li v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                          <div class="cartItems-content">
                            <p>{{ curIsEnglish ? item.Name : item.Description }}</p>
                            <p>${{ item.UnitPrice && item.UnitPrice.toFixed(2) }}</p>
                            <div class="quantity-container">
                              <div class="quantity-box">
                                <button @click="updateItemCount($event, item)"
                                        :class="item.Quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-
                                </button>
                                <p class="curr-quantity">{{ item.Quantity }}</p>
                                <button @click="throttleAddToCart(item, $event)" class="quantity-button">+</button>
                              </div>
                            </div>
                            <p>${{ item.TotalPrice && item.TotalPrice.toFixed(2) }}</p>
                            <img src="../assets/img/times.svg" @click="deleteItem(item)" style="cursor: pointer"/>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div style="display: none" class="order-summary__scroll-indicator">
                      {{ $t('scrollMoreItems') }}
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                </div>
                <div v-if="necessaryCartItems.Promotions && necessaryCartItems.Promotions.length > 0"
                     class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable"
                     ref="promoInfoBox">
                  <div class="promo-summary__section__content">
                    <p class="promo-summary__small-text">{{ $t('promotion') }}</p>
                    <table class="product-table">
                      <tr class="product" v-for="(item,index) in necessaryCartItems.Promotions">
                        <td @click="goToProductDetail(item)" class="product__image">
                          <div class="product-thumbnail">
                            <div class="product-thumbnail__wrapper">
                              <img :src="item.Thumbnail" alt="">
                            </div>
                            <span class="product-thumbnail__quantity">{{ item.Quantity }}</span>
                          </div>
                        </td>
                        <th class="product__description">
                          <span class="product__description__name order-summary__emphasis">{{ curIsEnglish ? item.Name : item.Description }}</span>
                          <span class="product__description__variant order-summary__small-text"></span>
                        </th>
                        <td class="product__price">
                            <span class="promo-summary__free">
                            {{ $t('free') }}
                             </span>
                        </td>
                      </tr>
                    </table>
                    <div style="display: none" class="order-summary__scroll-indicator">
                      {{ $t('scrollMoreItems') }}
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                </div>
                <div class="order-summary__section order-summary__section--total-lines"
                     :class="(scrollPosition < '-110') ? 'fixPosition':'' ">
                  <table class="total-line-table">
                    <tbody class="total-line-table__tbody">
                    <tr class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('subtotal') }}
                      </th>
                      <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{ TotalPrice && TotalPrice.toFixed(2) }}
                          </span>
                      </td>
                    </tr>
                    <tr class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('promotion') }}
                      </th>
                      <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{ Savings && Savings.toFixed(2) }}
                        </span>
                      </td>
                    </tr>
                    <tr class="total-line total-line--shipping">
                      <th class="total-line__name" style="paddingRight: 0">
                        {{ $t('shipping_fee') }}
                      </th>
                      <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{ necessaryCartItems.Delivery && necessaryCartItems.Delivery.toFixed(2) }}
                          </span>
                      </td>
                    </tr>
                    <tr class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('tax_afm') }}
                      </th>
                      <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{ necessaryCartItems.Tax }}
                          </span>
                      </td>
                    </tr>
                    <tr v-if="this.IsCreditUsed === true" class="total-line total-line--subtotal">
                      <th class="total-line__name">
                        {{ $t('credit') }}
                      </th>
                      <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{ necessaryCartItems.CreditAmount }}
                        </span>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot class="total-line-table__footer">
                    <tr class="total-line">
                      <th class="total-line__price total_name payment-due-label">
                      <span class="payment-due-label__total">
                        {{ $t('total') }}
                      </span>
                        <span class="payment-due-label__taxes order-summary__small-text hidden">
                        {{ $t('including') }}
                        <span class="">$0.00</span>
                        {{ $t('tax') }}
                      </span>
                      </th>
                      <td class="total-line__price usd_price payment-due">
                        <!-- <span class="payment-due__currency">
                          USD
                        </span> -->
                        <span class="payment-due__price">${{ this.GrandTotal }}</span>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                  <!-- <el-button :disabled="!isFormValidForSubmission()" @click="onSubmit('sizeForm')" class="place btn" style="marginTop: 50px;">{{ $t('placeOrder') }}</el-button>
                  <div v-if="this.orderFailed">
                    <span class="error-message">
                      Error: {{this.orderFailMessage}}
                    </span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--提示框-->
      <div class="refundContent">
        <el-dialog
          title="Refund policy"
          :visible.sync="this.refund"
          width="90%"
          :before-close="refundShow">
          <p>Refund Policy</p>
          <p>A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when
            merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due
            to
            an error made by J Town Express.</p>
          <p>Please note: J Town Express is not responsible for items opened or damaged due to high pressure/altitude.
            These items will not be refunded or accepted for return.</p>
          <p>Out of Stock Items</p>
          <p>Due to J Town Express's large variety of items and constant volume of sales, occasionally, items listed for
            sale on the e-store may be out of stock. J Town Express will issue an immediate refund for items ordered but
            currently not in stock.</p>
        </el-dialog>
      </div>
      <div class="privacyContent">
        <el-dialog
          title="Privacy policy"
          :visible.sync="this.privacy"
          width="90%"
        >
          <p>Privacy Notice</p>
          <p>This privacy notice discloses the privacy practices for jtownexpress.com. This privacy notice applies
            solely
            to information collected by this web site. It will notify you of the following:</p>
          <p>What personally identifiable information is collected from you through the web site, how it is used and
            with
            whom it may be shared.</p>
          <p>What choices are available to you regarding the use of your data.</p>
          <p>The security procedures in place to protect the misuse of your information. How you can correct any
            inaccuracies in the information.</p>
          <p>Information Collection, Use, and Sharing</p>
          <p>We are the sole owners of the information collected on this site. We only have access to/collect
            information
            that you voluntarily give us via email or other direct contact from you. We will not sell or rent this
            information to anyone.</p>
          <p>We will use your information to respond to you, regarding the reason you contacted us. We will not share
            your
            information with any third party outside of our organization, other than as necessary to fulfill your
            request,
            e.g. to ship an order.</p>
          <p>Unless you ask us not to, we may contact you via email in the future to tell you about specials, new
            products
            or services, or changes to this privacy policy.</p>
          <p>Your Access to and Control Over Information</p>
          <p>You may opt out of any future contacts from us at any time. You can do the following at any time by
            contacting us via the email address or phone number given on our website:</p>
          <p>See what data we have about you, if any.</p>
          <p>Change/correct any data we have about you.</p>
          <p>Have us delete any data we have about you.</p>
          <p>Express any concern you have about our use of your data.</p>
          <p>Security</p>
          <p>We take precautions to protect your information. When you submit sensitive information via the website,
            your
            information is protected both online and offline.</p>
          <p>Wherever we collect sensitive information (such as credit card data), that information is encrypted and
            transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of
            your
            web browser, or looking for "https" at the beginning of the address of the web page.</p>
          <p>While we use encryption to protect sensitive information transmitted online, we also protect your
            information
            offline. Only employees who need the information to perform a specific job (for example, billing or customer
            service) are granted access to personally identifiable information. The computers/servers in which we store
            personally identifiable information are kept in a secure environment.</p>
          <p>If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone
            at (888) 482-2742 or via email.</p>
        </el-dialog>
      </div>
      <!--end提示框-->
    </el-form>

<!--    选择送货时间-->
    <div class="popupbt selectTime" :class="{showpop:showpop}">
      <div class="model-pop" @click="showpop = !showpop"></div>
      <div class="pop-content">
        <div class="pop-title">{{ $t('schedule') }}</div>
        <div class="pop-select">
          <div class="pop-item selectTime-item" :class="{sel:deliveryTime == item.value}"
               @click="deliveryTime = item.value,showpop = !showpop" v-for="item in timeSlots">{{ item.name }}
          </div>
        </div>
        <div class="popBtn" @click="showpop = !showpop">Done</div>
      </div>
    </div>
<!--    选择提货地区-->
    <div class="popupbt pickTimepop" :class="{showpop:showPick}">
      <div class="model-pop" @click="showPick = !showPick"></div>
      <div class="pop-content">
        <div class="pop-title">Store Address</div>
        <div class="pop-select">
          <div class="pop-item" v-for="item in this.warehouses">
            <div class="pickLeft">
              <span></span>
            </div>
            <div>
              <div class="pickname">{{ item.name }}</div>
              <div class="pickaddress">{{ item.address }}</div>
            </div>
            <div class="comingsoon">coming soon</div>
          </div>
        </div>
        <div class="popBtn" @click="showPick = !showPick">Done</div>
      </div>
    </div>
<!--    必须得有这个，才会有google才会有值 -->
    <GmapMap v-show="false" :center='{lat: 47.678013, lng: -122.255167}' />
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import _ from 'lodash';
import moment from "moment";

import mbHeader from "../components/mobile/mbHeader";
import couponAutocomplete from "../components/coupon-autocomplete/coupon-autocomplete";
import {mapActions, mapMutations, mapState} from "vuex";
import {validateZipCode} from "../../config/validation";
import calendar from './calendar';
import {isUserAuthenticated} from '../store/modules/cart';
import {deleteAddress, locales, promoCodeList, validPhone} from "../mixin";

const PICKUP_TEXT = 'Pickup'
const DELIVERY_TEXT = 'Delivery'

export default {
  name: "purchase",
  components: {
    calendar,
    mbHeader,
    couponAutocomplete
  },
  mixins: [validPhone, deleteAddress, promoCodeList, locales],
  data() {
    return {
      showpop: false,
      showPick: false,
      isWx: false,
      pickUpDay: '',
      dateSelected: '',
      calendarClicked: false,
      warehouseChoice: '',
      selectedWarehouse: '',
      warehouses: [
        {
          name: 'Bellevue',
          address: '14515 NE 20th St, Bellevue, WA 98007',
          phone: '(425) 643-8558',
          hoursOne: 'Sun - Thurs, 9am - 9pm',
          hoursTwo: 'Fri - Sat, 9am - 10pm',
          value: '98007'
        },
        {
          name: 'Beaverton',
          address: '3849 SW 117TH Ave Beaverton, OR 97005',
          phone: '503-520-1880',
          hoursOne: 'Mon - Sun, 9am - 9pm',
          hoursTwo: '',
          value: '97005'
        },
        {
          name: 'Seattle',
          address: '13200 Aurora Ave N Seattle, WA 98133',
          phone: '206-367-1229',
          hoursOne: 'Mon - Sun, 9am - 10pm',
          hoursTwo: '',
          value: '98133'
        },
      ],
      shippingAddressSelected: '',
      billingAddressSelected: '',
      savedCardSelected: '',
      shippingAddress: {
        Name: '',
        Address: '',
        City: '',
        Zipcode: '',
        Method: '',
        Country: 'USA',
        Telephone: '',
      },
      billingAddress: {
        Name: '',
        Address: '',
        City: '',
        Zipcode: '',
        Method: '',
        Country: '',
        Telephone: '',
      },
      saveCard: false,
      sameAsShipping: false,
      saveShippingAddress: false,
      saveBillingAddress: false,
      isAddBilling: false,
      addressSelection: null,
      scrollPosition: null,
      accordionOpen: 'accordion',
      labelPosition: 'top',
      address: '',
      promoCode: '',
      card_holder_name: '',
      addressChoice: '',
      order: false,
      radio: '', // 单选框默认
      deliveryTime: '',
      pickUpTime: '',
      creditCardSuccess: false,
      savedCard: {},
      formLabelAlign: {
        name: '',
        password: '',
      },
      showPaymentError: false,
      paymentMethod: '',
      activeNames: ['1'],
      Subtotal: 15,
      total: 15,
      billingAddressSame: false,
      // 表单默认数据
      sizeForm: {
        name: "",
        subscribe: true,//是否订阅
        firstName: '',//名字
        lastName: '',//名字
        address: '',//地址
        apartment: '',//地址
        city: '',//城市
        code: '',//编码
        phone: '',//联系方式
        Country: 'United States', //国家/地区
        State: 'CA',//地区
        gateCode: '',//送货上门详细地址
        whether: 1,//是否确认
        confirmAddress: '',//确认地址
        Card: '',//卡号
        Expiration: '',//到期时间
        CVC: '',//安全码
        storage: true,//是否保存信息
        card_holder_name: '',
      },
      cardData: {
        cardNumber: null,
        expiry: null,
        cvc: null,
        // cardType: null,
        CardName: null,
        salesOrderId: null,
      },
      cardInfo: {
        Name: '',
        CardNumber: '',
        CVV: '',
        ExpirationDate: '',
      },
      saveCreditCard: false,
      rules: {
        firstName: [
          {required: true, message: 'First Name is Required', trigger: 'blur'},
          {min: 2, max: 20, message: 'first name length at least 3', trigger: 'blur'}
        ],
        lastName: [
          {required: true, message: 'Last Name is Required', trigger: 'blur'},
          {min: 2, max: 20, message: 'last name length at least 3', trigger: 'blur'}
        ],
        address: [
          {required: true, message: 'Address is required', trigger: 'blur'},
          {min: 2, max: 30, message: 'address length at least 3', trigger: 'blur'}
        ],
        city: [
          {required: true, message: 'City is Required', trigger: 'blur'},
          {min: 3, max: 20, message: 'city length at least 3', trigger: 'blur'}
        ],
        code: [
          {required: true, message: 'Zip Code is Required', trigger: 'blur'},
          {min: 3, max: 5, message: 'code length at least 3', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: 'Phone Number is Required', trigger: 'blur'},
          {min: 3, max: 12, message: 'phone length at least 3', trigger: 'blur'}
        ],
        Country: [
          {required: true, message: 'Country is Required', trigger: 'blur'},
          {min: 3, max: 20, message: 'Country length at least 3', trigger: 'blur'}
        ],
        Card: [
          {required: true, message: 'Card Info is Required', trigger: 'blur'},
          {min: 16, max: 23, message: 'Card number should be 13 - 19 digits', trigger: 'blur'},
        ],
        Expiration: [
          {required: true, message: 'Expiration Date is Required', trigger: 'blur'},
          {min: 5, max: 5, message: 'Expiration data shoud be in format MM/YY', trigger: 'blur'}
        ],
        CVC: [
          {required: true, message: 'Security Code is Required', trigger: 'blur'},
          {min: 3, max: 4, message: 'CVC length at least 3', trigger: 'blur'}
        ],
      },
      //下拉框默认数据
      stateOptions: this.$store.state.addresses.states, // States drop down data
      CountryList: [{
        value: '',
        label: '---'
      }, {
        value: 'United States',
        label: 'United States'
      }],

      // input label
      input_label: false,
      firstName: false,
      lastName: false,
      addressName: '',
      apartment: false,
      city: false,
      code: false,
      phone: false,
      privacy: false,
      refund: false,
      // end input label

      //商品列表默认数据
      isAddAddress: false,//展示添加地址
      isAddPayment: false,//展示添加支付方式

      //user credit
      IsCreditUsed: false,
      existingBankAccountId: null,
      paymentStep: 2,
      shippingMethod: '',
      deliveryChoice: 'select',
      deliveryMethod: DELIVERY_TEXT,
      stepOneValid: false,
      stepTwoValid: false,
      stepThreeValid: false,
      stepFourValid: false,
      stepLoading: false,
      autocomplete: null,
      timeoutAutocompleteId: null,
      orderDataNote: '',
      PICKUP_TEXT,
      DELIVERY_TEXT
    }
  },
  methods: {
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('navbar', ['updateShippingMethodGlobal']),
    ...mapMutations('cart', ['stopAddToCartLoading']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard', 'updatePromoCode', 'resetErrorMessages', 'savedCardUsed', 'resetSavedCard']),
    ...mapActions('checkout', ['fetchAchProfiles', 'fetchPickupTimeSlots', 'validatePromoCode']),
    storeDate(value) {
      this.dateSelected = value;
      this.pickUpTime='';
    },
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,19}/g);
      var match = matches && matches[0] || ''
      var parts = []
      for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
      }
      if (parts.length) {
        this.cardInfo.CardNumber = parts.join(' ')
      } else {
        this.cardInfo.CardNumber = value
      }
    },
    nextStep(e, selectStep, callback) {
      e.preventDefault();
      if (this.deliveryMethodIsPickup) {
        this.paymentStep = 3;
        // this.stepTwoValid = true;
        this.runAdjustCartAPI();
      } else {
        this.runAdjustCartAPI();
        this.paymentStep = selectStep;
      }
      setTimeout(() => {
        document.documentElement.scrollTop = 0;
      }, 300);
    },
    nextStepPayment(e) {
      e.preventDefault();

      // 店内取货的时候，手机号是必填的
      if (this.deliveryMethodIsPickup && !this.orderDataNote) {
        return
      }

      if (this.paymentMethod === 'wechatpay' || this.paymentMethod === 'alipay') {
        this.onSubmit(e);
      } else if (this.savedCardSelected) {
        this.fetchCardToken();
        this.onSubmit(e);
      } else {
        if (this.stepThreeValid) {
          this.paymentStep = 4;
        }
      }
    },
    nextStepAddress(e, selectStep, address) {
      e.preventDefault();
      this.onSubmit(e);
      return;
      let addressForm = address === 'shipping' ? this.shippingAddress : this.billingAddress;
      if (this.shippingAddressSelected) {
        this.paymentStep = 3;
          setTimeout(() => {
            document.documentElement.scrollTop = 0;
          }, 300);
        // if (this.checkoutWithinRadius) {
        //   this.paymentStep = 3;
        //   setTimeout(() => {
        //     document.documentElement.scrollTop = 0;
        //   }, 300);
        // } else {
        //   this.stepTwoValid = false;
        // }
      } else {
        const callback = () => {
          this.shippingAddressSelected = this.addresses[this.addresses.length - 1]
          setTimeout(() => {
            document.documentElement.scrollTop = 0;
          }, 300);
        }
        this.postNewAddress(addressForm, 'shipping', e, callback)
      }
    },
    postBillingAndSubmitOrder(e) {
      e.preventDefault();
      if (this.billingAddressSame || this.billingAddressSelected) {
        this.onSubmit(e);
      } else {
        const callback = () => {
          this.billingAddressSelected = this.addresses[this.addresses.length - 1];
          this.onSubmit(e);
        }
        this.postNewAddress(this.billingAddress, 'billing', e, callback)
      }
    },
    clearShipping() {
      this.shippingAddressSelected = '';
    },
    clearBilling() {
      this.billingAddressSelected = '';
    },
    selectDeliveryMethod(e, method) {
      e.preventDefault();
      if (method === PICKUP_TEXT) {
        this.deliveryChoice = '';
      }
      if (method === DELIVERY_TEXT && !this.oneDayDelivery) {
        this.deliveryChoice = 'select'
      }
      this.deliveryMethod = method;

      this.$store.dispatch('cart/saveAndAdjustCart', {
        ...this.necessaryCartItems,
        ShippingMethod: this.deliveryMethod
      }).then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    },
    shippingAddressValid() {
      let valid = false;
      if (this.shippingAddressSelected) {
        // if (this.checkoutWithinRadius) {
          valid = true;
        // }
      } else {
        if (this.checkShippingForm()) {
          valid = true;
        }
      }
      return valid
    },
    billingAddressValid() {
      let valid = false;
      if (this.billingAddressSelected) {
        valid = true;
      } else if (this.billingAddressSame) {
        valid = true;
      } else {
        if (this.checkBillingForm()) {
          valid = true;
        }
      }
      return valid
    },
    checkBillingForm() {
      let valid = false;
      if (this.billingAddress.Name !== '' && this.billingAddress.Address !== '' && this.billingAddress.City !== '' && this.billingAddress.Zipcode !== '') {
        valid = true;
      }
      return valid;
    },
    checkShippingForm() {
      let valid = false;
      if (this.shippingAddress.Name !== '' && this.shippingAddress.Address !== '' && this.shippingAddress.City !== '' && this.shippingAddress.Zipcode !== '' && this.shippingAddress.Telephone !== '') {
        valid = true;
      }
      return valid;
    },
    paymentFormValid() {
      if (this.checkCreditCardForm()) {
        this.stepThreeValid = true;
      } else {
        this.stepThreeValid = false;
      }
    },
    checkCreditCardForm() {
      let valid = false;
      if (this.cardInfo.Name !== '' && this.cardInfo.CardNumber !== '' && this.cardInfo.CVV !== '' && this.cardInfo.ExpirationDate !== '') {
        valid = true;
      }
      return valid;
    },
    clearSavedCard() {
      if (this.savedCardSelected) {
        this.savedCardSelected = '';
        if (!this.checkCreditCardForm()) {
          this.stepThreeValid = false;
        }
      }
    },
    cardExpireDateFormatter(date) {
      if (date.length == 3) {
        if (date[date.length - 1] !== '/') {
          var temp = this.cardInfo.ExpirationDate.split('');
          temp.splice(2, 0, '/');
          this.cardInfo.ExpirationDate = temp.join('');
          return;
        } else {
          this.cardInfo.ExpirationDate = this.cardInfo.ExpirationDate.slice(0, 2);
        }
      }
    },
    throttleAddToCart: _.debounce(function (item, e) {
      e.preventDefault();
      this.addToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function (item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({
            success: this.handleAddToCartSuccess,
            fail: this.handleAddToCartFail,
            item,
            event: event
          })
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail(product) {
      this.stopAddToCartLoading();
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    updateItemCount(e, item) {
      e.preventDefault();
      if (isUserAuthenticated()) {
        let quantity = item.Quantity - 1;
        if (quantity < 1) {
          this.deleteItem(item);
        } else {
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
        }
      } else {
        item.quantity = item.quantity - 1;
        if (item.quantity < 1) {
          this.deleteItem(item)
        }
        this.$store.dispatch('cart/updateLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/fetchCartProducts');
          })
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    updateScroll() {
      this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
    },
    refundShow() {
      this.refund = !this.refund
    },
    async validatePromotionCode(e) {
      e.preventDefault();
      const res = await this.validatePromoCode([this.promoCode, this.TotalPrice])
      if (typeof res === 'boolean') {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = this.deliveryMethod;
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.PromoCode = this.PromoCode;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems).finally(() => {console.log(555)})
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      }
      !res && (this.promoCode = '')
    },
    goBackToStep(e, step, valid) {
      e.preventDefault();
      if (step === 2 && this.deliveryMethodIsPickup) {
        return;
      }
      if (valid) {
        this.paymentStep = step;
      }
    },
    checkForm: async function (form, type) {
      this.errors = [];
      if (!form.Street) {
        this.errors.push(this.$t('addressRequired'))
      }
      ;
      if (!form.City) {
        this.errors.push(this.$t('cityRequired'))
      }
      ;
      if (validateZipCode(form.Zip)) (
        this.errors.push(this.$t('zipCodeWrong'))
      );
      // if (type === 'shipping') {
        if ((form.Telephone).replace(/\D/g, '').length !== 10) {
          this.errors.push(this.$t('phoneFormat'))
        }
      // }
    },
    findWarehouse() {
      this.selectedWarehouse = this.warehouses.find(x => x.name === this.warehouseLocation);
    },
    postNewAddress(form, type, e, callback, submit) {
      e.preventDefault();
      let name = form.Name.split(' ');
      const address = {};
      address.Street = form.Address
      address.City = form.City;
      address.Zip = form.Zipcode;
      address.Country = form.Country;
      // if (type === 'shipping') {
        address.Telephone = (form.Telephone).replace(/\D/g, '');
      // }
      if (name.length === 1) {
        address.FirstName = form.Name;
      } else {
        address.FirstName = name[0];
        address.LastName = name[1];
      }
      this.checkForm(address, type);
      if (!this.errors.length) {
        this.$store.dispatch('addresses/postAddress', [address, type])
          .then(() => {
            this.$store.dispatch('addresses/fetchAddresses', callback);
          })
      } else {
        // if (!this.shippingAddressSelected) {
        //   alert(this.errors);
        // }
        alert(this.errors);
      }
    },
    onSubmit(e) {
      e.preventDefault();
      let shippingAddress = this.addresses.filter(item => item.CustomerDetail_id === this.shippingAddressSelected);
      let billingAddress = this.addresses.filter(item => item.CustomerDetail_id === this.billingAddressSelected);
      let orderData = {};
      let time = moment()._d;
      orderData.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      orderData.FinalPrice = this.TotalPrice;
      orderData.TotalPrice = this.necessaryCartItems.GrandTotal;
      orderData.GrandTotal = this.necessaryCartItems.GrandTotal;
      orderData.SalesOrder_id = this.salesOrderId;
      orderData.ShippingMethod = this.deliveryMethod;
      orderData.PaymentMethod = this.paymentMethod;
      orderData.terminal = this.device;
      orderData.PromoCode = this.usePromoCode;
      orderData.Savings = this.Savings;

      if (this.deliveryMethodIsDelivery) {
        orderData.DispatchDate = this.deliveryTime ? this.deliveryTime : this.timeSlots[0].value;
        orderData.TimeSlot = orderData.DispatchDate;
      } else if (this.deliveryMethodIsPickup) {
        orderData.DispatchDate = this.dateSelected + ' 00:00:00'
        orderData.TimeSlot = this.pickUpTime;
        orderData.Note = this.orderDataNote
      }

      if (this.billingAddressSame) {
        orderData.Billing_CustomerDetail_id = orderData.Deliver_CustomerDetail_id;
      } else if (this.billingAddressSelected) {
        orderData.Billing_CustomerDetail_id = typeof this.billingAddressSelected === 'object' ? this.billingAddressSelected.CustomerDetail_id : billingAddress[0].CustomerDetail_id
      }

      if (this.deliveryMethodIsDelivery) {
        orderData.Deliver_CustomerDetail_id = typeof this.shippingAddressSelected === 'object' ? this.shippingAddressSelected.CustomerDetail_id : shippingAddress[0].CustomerDetail_id;
      } else {
        // orderData.warehouse_zipcode = localStorage.getItem('userZipcode');
        orderData.Deliver_CustomerDetail_id = null;
      }
      for (const key in this.necessaryCartItems) {
        if (!orderData.hasOwnProperty(key)) {
          if (this.deliveryMethodIsDelivery) {
            orderData.Delivery = this.necessaryCartItems[DELIVERY_TEXT]
          } else {
            orderData.Delivery = 0;
          }
          if (key !== DELIVERY_TEXT) {
            orderData[key] = this.necessaryCartItems[key];
          }
        }
      }
      if (this.paymentMethod === 'creditcard') {
        if (this.saveCard || this.savedCardSelected) {
          orderData.PaymentMethod = 'saved_card';
          if (this.savedCardSelected) {
            orderData.existingCard = this.savedCardSelected;
            orderData.card_reference = this.card_reference;
          } else {
            let card_reference = {};
            card_reference.cardNum = this.cardInfo.CardNumber.split(' ').join('')
            card_reference.expDate = '20' + this.cardInfo.ExpirationDate.split("/").reverse().join("-");
            orderData.card_reference = card_reference;
          }
        } else {
          let card_reference = {};
          card_reference.cardNum = this.cardInfo.CardNumber.split(' ').join('')
          card_reference.expDate = '20' + this.cardInfo.ExpirationDate.split("/").reverse().join("-");
          card_reference.cvv = this.cardInfo.CVV;
          card_reference.salesOrderId = this.salesOrderId;
          card_reference.card_holder_name = this.cardInfo.Name;
          orderData.card_reference = card_reference;
        }
      }
      this.$store.dispatch('checkout/submitOrder', orderData);
    },
    fetchCardToken() {
      let paymentData = {};
      paymentData.cardNum = this.cardInfo.CardNumber.split(' ').join('')
      paymentData.expDate = '20' + this.cardInfo.ExpirationDate.split("/").reverse().join("-");
      paymentData.cvv = this.cardInfo.CVV;
      paymentData.salesOrderId = this.salesOrderId;
      paymentData.card_holder_name = this.cardInfo.Name;
      this.$store.dispatch('checkout/saveCreditCard', paymentData)
    },
    validateAddress() {
      this.$store.dispatch('navbar/validateDeliveryRadius',);
    },
    validateDeliveryRadiusCheckout(event, address) {
      this.$store.dispatch('navbar/validateDeliveryRadius', address.Zip);
    },
    addAddress() {
      this.isAddAddress = !this.isAddAddress;
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({
        name: 'productDetails',
        query: {
          productNum: product.ProductNum,
        }
      })
    },
    runAdjustCartAPI() {
      this.stepLoading = true;
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.Tip = 0;
      cartItems.ShippingMethod = this.deliveryMethod;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.PromoCode = this.usePromoCode;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          this.stepLoading = false;
        }).finally(() => {console.log(444)})
    },
    clearStepItems() {
      this.shippingAddressSelected = '';
      this.billingAddressSelected = '';
      this.savedCardSelected = '';
      this.stepOneValid = false;
      this.stepTwoValid = false;
      this.stepThreeValid = false;
      this.stepFourValid = false;
      this.cardInfo = _.mapValues(this.cardInfo, () => '');
      this.shippingAddress = _.mapValues(this.shippingAddress, () => '');
      this.billingAddress = _.mapValues(this.billingAddress, () => '');
      this.paymentStep = 2;
      this.saveCard = false;
      this.sameAsShipping = false;
      this.saveShippingAddress = false;
      this.saveBillingAddress = false;
      this.deliveryMethod = DELIVERY_TEXT;
      this.deliveryTime = '';
      this.resetErrorMessages();
    },
    initAutocomplete() {// 把地址提示去掉
      return;
      const google = this.google
      if (!google) {
        this.timeoutAutocompleteId = setTimeout(() => {
          this.initAutocomplete()
        }, 1000)
        return
      }
      this.autocomplete = new google.maps.places.Autocomplete(this.$refs['ship-address'], {
        componentRestrictions: {
          country: ["us"]
        },
        fields: ["address_components", "geometry"],
        types: ["address"],
      });
      this.autocomplete.addListener("place_changed", this.fillInAddress);
    },
    fillInAddress() {
      const place = this.autocomplete.getPlace();
      let address1 = "";
      let postcode = "";
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "postal_code_suffix": {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case "locality":
            this.shippingAddress.City = component.long_name;
            break;
          case "administrative_area_level_1": {
            const state = document.querySelector("#state")
            state && (state.value = component.short_name);
            break;
          }
          // case "country":
          //   this.$refs['country'].value = component.long_name;
          //   break;
        }
      }
      this.shippingAddress.Address = address1;
      this.shippingAddress.Zipcode = postcode;
    },
    setPromoCodeVal() {
      this.promoCode = localStorage.getItem('beforeRefreshPromoCode') || ''
      if (!this.PromoCode && this.promoCode) {
        this.$store.state.checkout.PromoCode = this.promoCode
      }
    },
    delAddressCallback(id) {
      if (this.shippingAddressSelected !== id) {
        return
      }
      this.clearShipping()
    },
    resetPromotionCode() {
      this.clearPromoCode();
      this.promoCode = '';
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    if (this.addresses.length) {
      let id = this.addresses[0].Customer_id
      this.fetchAchProfiles([id, this.warehouseLocation]);
    }
    this.resetSavedCard();
    this.deliveryMethod = this.shippingMethodGlobal;
    this.findWarehouse();

    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
      this.isWx = true;
      return true;
    }
  },
  beforeMount() {
    this.$store.dispatch('cart/getCart')
      .then(() => {
        this.setPromoCodeVal();
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        // cartItems.ShippingMethod = "Delivery";
        cartItems.ShippingMethod = this.deliveryMethod;
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.PromoCode = this.usePromoCode;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          }).finally(() => {console.log(333)})
      })
    this.$store.dispatch('checkout/fetchTimeSlots');
    this.$store.dispatch('addresses/fetchAddresses');
  },
  watch: {
    billingAddressSelected: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.billingAddressSame = false;
      }
    },
    savedCardSelected: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.savedCardUsed(newVal.billto)
        this.stepThreeValid = true;
      }
    },
    deliveryMethod: function (newVal, oldVal) {
      if (newVal === PICKUP_TEXT && oldVal === DELIVERY_TEXT) {
        this.updateShippingMethodGlobal(PICKUP_TEXT);
        this.deliveryTime = '';
        this.stepOneValid = false;
        this.warehouseChoice = this.selectedWarehouse.value;
      }
      if (newVal === DELIVERY_TEXT && oldVal === PICKUP_TEXT) {
        this.updateShippingMethodGlobal(DELIVERY_TEXT)
        this.pickUpTime = '';
        this.dateSelected = '';
        this.deliveryTime = '';
        this.stepOneValid = false;
      }
    },
    deliveryChoice: function (newVal, oldVal) {
      if (newVal === 'oneDay' && newVal !== oldVal) {
        this.$store.dispatch('checkout/fetchTimeSlots');
        this.deliveryTime = '';
        this.stepOneValid = true;
      }
      if (newVal === 'select' && newVal !== oldVal) {
        this.$store.dispatch('checkout/fetchTimeSlotsNext');
        this.stepOneValid = false;
      }
    },
    deliveryTime: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.stepOneValid = true;
      }
    },
    oneDayDelivery: function (newVal, oldVal) {
      if (newVal === false && newVal !== oldVal) {
        this.deliveryChoice = 'select';
      }
    },
    shippingAddressSelected: function (newVal, oldVal) {
      if (newVal !== oldVal && typeof newVal === 'number') {
        let address = this.addresses.filter(item => item.CustomerDetail_id === newVal);
        this.stepTwoValid = true;
        this.validateDeliveryRadiusCheckout(null, address[0])
      } else if (newVal !== oldVal && typeof newVal !== 'number') {
        let address = this.addresses.filter(item => item.CustomerDetail_id === newVal.CustomerDetail_id);
        this.stepTwoValid = true;
        this.validateDeliveryRadiusCheckout(null, address[0])
      }
    },
    IsCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        cartItems.PromoCode = this.usePromoCode;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          }).finally(() => {console.log(222)})
      }
    },
    isAddAddress: function (newVal, oldVal) {
      immediate: true;
      if (newVal === true && oldVal === false) {
        this.addressChoice = '';
      }
    },
    addresses: function (newVal, oldVal) {
      if (newVal !== oldVal || newVal.length !== oldVal.length) {
        this.addresses.map(address => {
          if (address.IsDefault) {
            this.addressChoice = address;
            this.addressName = address.FirstName + ' ' + address.LastName;
          }
        });
      }
    },
    addressChoice: function (newVal, oldVal) {
      // reset the error message for payment
      this.showPaymentError = false;

      if (newVal !== oldVal) {
        this.addresses.map(address => {
          if (address.CustomerDetail_id === this.addressChoice.CustomerDetail_id) {
            this.addressName = address.FirstName + ' ' + address.LastName;
          }
        });
      }
      ;
      if (oldVal === '' && newVal !== oldVal) {
        this.isAddAddress = false;
      }
    },
    cardLoading: function (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.isAddPayment = false;
      }
    },
    promoCodeSuccessful: function (newVal, oldVal) {
      if (newVal === true) {
        let value = ((this.TotalPrice - this.Savings.toFixed(2)) + this.necessaryCartItems.Tax + this.necessaryCartItems.Delivery).toFixed(2);
        this.saveGrandTotal(Number(value));
      }
    },
    necessaryCartItems: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updatePromoCode(this.necessaryCartItems.Savings);
      }
    },
    pickUpTime: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (this.dateSelected) {
          this.stepOneValid = true;
        }
      }
    },
    dateSelected: function (newVal, oldVal) {
      this.fetchPickupTimeSlots(newVal)
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        if (newVal && this.$route.name === 'purchase') {
          if (!newVal.Sales_Order_Lines || !newVal.Sales_Order_Lines.length) {
            this.$router.push('collections')
          }
          this.setPromoCodeVal();

          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.Tip = 0;
          cartItems.ShippingMethod = this.deliveryMethod;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.PromoCode = this.usePromoCode;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            }).finally(() => {console.log(111)})
          this.resetErrorMessages();
        }
      }
    },
    paymentMethod: function (newVal, oldVal) {
      if ((newVal === 'creditcard') && newVal !== oldVal) {
        this.stepThreeValid = false;
        if (this.addresses.length) {
          let id = this.addresses[0].Customer_id
          this.fetchAchProfiles([id, this.warehouseLocation]);
        }
      }
      if (newVal !== 'creditcard' && newVal !== oldVal) {
        this.stepThreeValid = true;
        this.savedCardSelected = '';
      }
    },
    warehouseChoice: function (newVal, oldVal) {
      this.$store.dispatch('navbar/validateDeliveryRadius', newVal);
    },
    paymentStep(newVal) {
      if (newVal !== 2) return;
      this.$nextTick(() => {
        this.initAutocomplete();
      })
    },

  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('cart/getCart')
      .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.PromoCode = this.usePromoCode;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          }).finally(() => {console.log(666)})
      });
    this.clearPromoCode();
    this.IsCreditUsed = false;
    this.clearCard();
    this.clearStepItems();
    next();
  },
  activated() {
    this.promoCode && this.validatePromotionCode({preventDefault:function () {}})
  },
  deactivated() {
    clearTimeout(this.timeoutAutocompleteId);
    localStorage.removeItem('beforeRefreshPromoCode')
    localStorage.removeItem('promo-code')
  },
  beforeCreate() {
    const localPromoCode = localStorage.getItem('promo-code');
    localStorage.setItem('beforeRefreshPromoCode', localPromoCode || '');
  },
  computed: {
    ...mapState({
      salesOrderId: state => state.cart.cartProductsList.SalesOrder_id,
      card_reference: state => state.checkout.card_reference,
      timeSlots: state => state.checkout.timeSlots,
      addresses: state => state.addresses.customerDetails,
      customerDetails: state => state.profile.customerDetails,
      necessaryCartItems: state => state.cart.necessaryCartItems,
      cartProductsList: state => state.cart.cartProductsList,
      device: state => state.navbar.device,
      orderLoading: state => state.checkout.orderLoading,
      orderSuccessful: state => state.checkout.orderSuccessful,
      cardLoading: state => state.checkout.cardLoading,
      cardSuccess: state => state.checkout.cardSuccess,
      cardError: state => state.checkout.cardError,
      checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
      promoCodeLoading: state => state.checkout.promoCodeLoading,
      promoCodeSuccessful: state => state.checkout.promoCodeSuccessful,
      promoCodeError: state => state.checkout.promoCodeError,
      promoCodeValid: state => state.checkout.promoCodeValid,
      promoCodeValid_ch: state => state.checkout.promoCodeValid_ch,
      PromoCode: state => state.checkout.PromoCode,
      Savings: state => state.checkout.Savings,
      GrandTotal: state => state.checkout.GrandTotal,
      TotalPrice: state => state.checkout.TotalPrice,
      Tax: state => state.checkout.Tax,
      cartClicked: state => state.cart.cartClicked,
      itemCount: state => state.cart.itemCount,
      windowOpening: state => state.checkout.windowOpening,
      orderFailed: state => state.checkout.orderFailed,
      orderFailMessage: state => state.checkout.orderFailMessage,
      savedCards: state => state.checkout.savedCards,
      itemDeletedLoading: state => state.cart.itemDeletedLoading,
      addToCartLoading: state => state.cart.addToCartLoading,
      oneDayDelivery: state => state.checkout.oneDayDelivery,
      warehouseLocation: state => state.navbar.warehouseLocation,
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
      pickUpTimeSlots: state => state.checkout.pickUpTimeSlots,
      isMobile() {
        return this.windowWidth < 800;
      }
    }),
    google: gmapApi,
    deliveryMethodIsPickup() {// 是否是店内取货
      return this.deliveryMethod === PICKUP_TEXT
    },
    deliveryMethodIsDelivery() {// 是否是配送
      return this.deliveryMethod === DELIVERY_TEXT
    },
    usePromoCode() {
      const localPromoCode = this.PromoCode || this.necessaryCartItems.PromoCode
      localPromoCode && localStorage.setItem('promo-code', localPromoCode || '')
      return localPromoCode
    },
    notValid({promoCodeError, curIsChinese, promoCodeValid, promoCodeValid_ch}) {
      if (promoCodeError) return promoCodeError
      if (curIsChinese && promoCodeValid_ch) return promoCodeValid_ch
      return promoCodeValid
    }
  },
}
</script>

<style lang="less">
@import "../assets/css/checkout.less";
@import "../assets/css/animation.less";
</style>



// WEBPACK FOOTER //
// src/view/checkout.vue